import React, { useContext, useState } from 'react';
import AppContext from "../../AppContext";
import { GenForm } from '../Hocs/Hocs';
import { FormService, Api, ModalService, Lang } from "./../../services/Services";
import { BaseSubmit, InputDiv, RegiBtns } from "./../utils/Utils";
import ForgotPassword from "./ForgotPassword";
import ForgotUsername from "./ForgotUsername";
import InitSecondHandAccount from "./InitSecondHandAccount";


const fields = [
	{ name: "email", label: "Email", validation: { isEmail: true, notEmpty: true }, placeholderLang: ["activate_login", "label_email"], toLowerCase: true },
	{ name: "password", label: "Password", type: "password", validation: { notEmpty: true }, placeholderLang: ["activate_login", "label_password"] },
];
const fieldsObj = {};
const apiFunc = async () => await Api.login(fieldsObj.email[0], fieldsObj.password[0]);

const langText = (area, term, fallback) => {
	if (Lang[area] && Lang[area][term]) {
		return Lang[area][term];
	}
	return fallback;
};


const Login = ({ errors, submit, servError, initialHelpView, onSwitchToRegister }) => {
	const context = useContext(AppContext);
	const [loginHelpView, loginHelpViewUpd] = useState(initialHelpView || null);
	const [initActivationCode, initActivationCodeUpd] = useState(context.UserService.activationCode || "");

	fieldsObj.email = useState("");
	fieldsObj.password = useState("");



	const submitFunc = async () => {
		let res = await submit();
		if (res && res.account) {
			context.UserService.updateInfo({ user: res.account, curPlayerId: res.playerId });
			// history.push("/");
			ModalService.closeBlueCover();
			if (context.UserService.isGoToPlay) {
				context.UserService.goToGames();
			}
		}
	}

	const seekFocus = posToLook => {
		FormService.seekFocus(posToLook, fields, submitFunc);
	}

	const closeHelpView = () => {
		if (context.UserService.user) {
			ModalService.closeBlueCover();
			return;
		}
		loginHelpViewUpd(null);
	};

	FormService.fieldsHoist(fields, fieldsObj);

	if (loginHelpView === "forgotPassword") {
		return <ForgotPassword closeForgot={closeHelpView} onOpenForgotUsername={() => loginHelpViewUpd("forgotUsername")} />;
	}
	if (loginHelpView === "forgotUsername") {
		return <ForgotUsername
			closeForgot={closeHelpView}
			onOpenInitSecondHand={(code) => {
				if (code) {
					context.UserService.activationCode = code;
					initActivationCodeUpd(code);
				}
				loginHelpViewUpd("initSecondHand");
			}}
		/>;
	}
	if (loginHelpView === "initSecondHand") {
		return (
			<InitSecondHandAccount
				activationCode={initActivationCode}
				onBack={() => loginHelpViewUpd("forgotUsername")}
				onPaymentSuccess={(code) => {
					if (code) { context.UserService.activationCode = code; }
					if (onSwitchToRegister) { onSwitchToRegister(code); }
					else { closeHelpView(); }
				}}
			/>
		);
	}

	if (context.UserService.user) { return null; }

	return (
		<>
			<ul className="form">
				{
					fields.map((fieldObj, k) => <li key={fieldObj.name}><InputDiv tabIndex={k + 1} fieldObj={fieldObj} error={errors[fieldObj.name]} seekFocus={seekFocus} /></li>)
				}
				<li>
					<p>
						<span className="form-p underline pointer" onClick={() => loginHelpViewUpd("forgotPassword")} >{Lang.activate_login.forgot_your_password}</span>
					</p>
					<p>
						<span className="form-p underline pointer" onClick={() => loginHelpViewUpd("forgotUsername")} >{langText("activate_login", "forget_password_or_username", "Forgot password or username?")}</span>
					</p>
				</li>

			</ul>
			<RegiBtns servError={servError} >
				<BaseSubmit onClick={submitFunc} label={Lang.activate_login.butten_login} />
			</RegiBtns>

		</>

	);
}

export default GenForm(Login, { fields, apiFunc, langFail: ["errorTexts", "login_fail"], langSuc: ["errorTexts", "login_suc"] });
